export function getDatesBetween(startDate: string | Date, endDate: string | Date): string[] {

    if (!startDate) {
        const today = new Date();
        
        const dates = [today.toISOString().split('T')[0]];

        return dates;
    }

    const dates: string[] = [];
    const start = typeof startDate === "string" ? new Date(startDate) : startDate;
    const end = typeof endDate === "string" ? new Date(endDate) : endDate;

    for (let dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
        dates.push(dt.toISOString().split('T')[0]);
    }

    return dates;
}